/* tslint:disable */
/* eslint-disable */
/**
 * Admin API
 * Internal Admin API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  GetDevicePinAccess200Response,
} from '../models/index';
import {
    GetDevicePinAccess200ResponseFromJSON,
    GetDevicePinAccess200ResponseToJSON,
} from '../models/index';

/**
 * 
 */
export class DevicesApi extends runtime.BaseAPI {

    /**
     */
    async getDevicePinAccessRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GetDevicePinAccess200Response>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/devices/pin`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GetDevicePinAccess200ResponseFromJSON(jsonValue));
    }

    /**
     */
    async getDevicePinAccess(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GetDevicePinAccess200Response> {
        const response = await this.getDevicePinAccessRaw(initOverrides);
        return await response.value();
    }

}
